import React from 'react'
import MUIDataTable from "mui-datatables";
import "../assets/css/style.css"
import MuiTableExpander from './MuiTableExpander'
import Button from 'react-bootstrap/Button';
import qs from 'qs';
import axiosInstance from '../axiosInstance'
import Modal from 'react-bootstrap/Modal'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import UpdateModal from './UpdateModal'

import { withRouter } from 'react-router-dom';

import ButtonToolbar from 'react-bootstrap/ButtonToolbar'
import { Page,Document,PDFDownloadLink } from '@react-pdf/renderer';


const MyDoc = () => (
    <Document>
      <Page>
        // My document data
      </Page>
    </Document>
  )
const columns = [
    {
        name: "account_id",
        label: "საბილინგოN",
        options: {
         filter: false,
         sort: true,
        }
    },
    {
     name: "type",
     label: "აღწერა",
     options: {
      filter: false,
      sort: false,
     }
    },
    {
     name: "status",
     label: "სტატუსი",
     options: {
        filter: false,
        sort: false,
        setCellProps: (value) => {
            var backgroundColor = "#34eb52";
            var color = "white";

            if(value ==="მიმდინარე")backgroundColor = "#deb500";
            if(value === 'გახსნილი')backgroundColor = "#d93425";
            if(value === 'შესრულებული'){
                backgroundColor = "#76b502";
            }
            if(value === 'დახურული')backgroundColor = "#1aba5a";
            return {   
            style: {
                        "backgroundColor": backgroundColor,
                        "color":color,
                        "textAlign":"center"
                }
            };
        },
     }
    },
    {
     name: "open_date",
     label: "გახსნის თარიღი",
     options: {
      filter: false,
      sort: true,
     }
    },
    {
     name: "close_date",
     label: "დახურვის თარიღი",
     options: {
      filter: false,
      sort: true,
     }
    },
    {
        name: "installer",
        label: "ინსტალატორი",
        options: {
         filter: false,
         sort: false,
        }
    },
    {
        name: "operator",
        label: "ოპერატორი",
        options: {
         filter: false,
         sort: false,
        }
    },
    {
        name:'first_name',
        label:'სახელი',
        options:{
            display:false
        }
    },
    {
        name:'second_name',
        label:'გვარი',
        options:{
            display:false
        }
    },
    {
        name:'address',
        label:'მისამართი',
        options:{
            display:false
        }
    },
    {
        name:'city',
        label:'ქალაქი',
        options:{
            display:false
        }
    }, 
    {
        name:'phone',
        label:'მობილური',
        options:{
            display:false
        }
    },
    {
        name:'comment',
        label:'კომენტარი',
        options:{
            display:false
        }
    },
    {
        name: "id",
        label: "საბილინგოN",
        options: {
         filter: false,
         sort: true,
         display:false
        }
    },
    {
        name: "personal_number",
        label: "პირადი ნომერი",
        options: {
         filter: false,
         sort: true,
         display:false
        }
    }    
   ];
   



   const indexes= {
    'account_id':0,
    'type':1,
    'status':2,
    'open_date':3,
    'close_date':4,
    'comment':5,
    'phone':6,
    'installer':7,
    'first_name':8,
    'second_name':9,
    'address':10,
    'city':11,
    'id':12

}
   const GETColumns=[
    {
        data: 'account_id',
        name: 'საბილინგოN',
        searchable:true,
        orderable:true,
        search:{
            value:null,
            regex:false
        },
        selector: 'account_id',
        sortable: true,
        index:0
    },
    {
        data: 'ticket_type',
        name: 'ტიპი',
        searchable:true,
        orderable:true,
        search:{
            value:null,
            regex:false
        },
        selector: 'type',
        index:1
    },
    {
        data:'status',
        name: 'სტატუსი',
        searchable:true,
        orderable:true,
        search:{
            value:null,
            regex:false
        },
        selector: 'status',
        index:2
    },
    {
        data: 'open_date',
        name: 'გახსნა',
        searchable:true,
        orderable:true,
        search:{
            value:null,
            regex:false
        },
        selector: 'open_date',
        sortable: true,
        minWidth:'200px',
        index:3
    },
    {
        data:'close_date',
        name: 'დაიხურა',
        searchable:true,
        orderable:true,
        search:{
            value:null,
            regex:false
        },
        selector: 'close_date',
        sortable: true,
        minWidth:'200px',
        index:4
    },
    
    {
        data:'comment',
        name: 'კომენტარი',
        searchable:true,
        orderable:true,
        search:{
            value:null,
            regex:false
        },
        selector: 'comment',
        maxWidth:'300px',
        index:5
    },
    {
        data:'phone',
        name: 'მობილური',
        searchable:true,
        orderable:false,
        search:{
            value:null,
            regex:false
        },
        selector: 'phone',
        index:6
    },
    {
        data: 'installer',
        name: 'ინსტალატორი',
        searchable:true,
        orderable:true,
        search:{
            value:null,
            regex:false
        },
        selector: 'installer',
        index:7
    },
    {
        data: 'first_name',
        name: 'ინსტალატორი',
        searchable:true,
        orderable:true,
        search:{
            value:null,
            regex:false
        },
        index:8
    },
    {
        data: 'second_name',
        name: 'ინსტალატორი',
        searchable:true,
        orderable:true,
        search:{
            value:null,
            regex:false
        },
        index:9
    },
    {
        data: 'address',
        name: 'ინსტალატორი',
        searchable:true,
        orderable:true,
        search:{
            value:null,
            regex:false
        },
        index:10
    },
    {
        data: 'city',
        name: 'ქალაქი',
        searchable:true,
        orderable:true,
        search:{
            value:null,
            regex:false
        },
        index:11
    },
    {
        data: 'id',
        name: 'id',
        searchable:true,
        orderable:true,
        search:{
            value:null,
            regex:false
        },
        selector: 'account_id',
        sortable: true,
        index:12
    },
    {
        data: 'personal_number',
        name: 'personal_number',
        searchable:true,
        orderable:true,
        search:{
            value:null,
            regex:false
        },
        selector: 'personal_number',
        sortable: true,
        index:13
    }
]

class MuiTable extends React.Component{

    constructor(){
        super();
        this.onchangedPage = this.onchangedPage.bind(this);
        this.onchangedRowsPerPaged = this.onchangedRowsPerPaged.bind(this);
        this.onSort = this.onSort.bind(this);
        this.onCustomToolbarSelect = this.onCustomToolbarSelect.bind(this);
        this.closeData = this.closeData.bind(this);
        this.deleteData = this.deleteData.bind(this);
        this.tableRef =  React.createRef();
        this.onFinishTicket = this.onFinishTicket.bind(this);
        this.childRed = React.createRef();
        this.state = {
            show:false,
            modal_show:false,
            modal_text:"",
            modal_ok_function:null,
            done_modal:false,
            close_modal:false,
            ticket_id:0,
            data:[],
            updatingData:null,
            paginationPerPage:10,
            currentPage:0,
            paginationTotalRows:null,
            order:{
                column:'open_date',
                dir:'desc',
                index:3
            },
            options:{
                page:0,
                serverSide:true,
                count:100,
                download : false,
                print: false,
                viewColumns:false,
                expandableRows:true,
                selectableRowsHeader:false,
                filter:false,
                search:false,
                selectableRows:"single",
                rowsSelected:[],
                onColumnSortChange:this.onSort,
                onChangeRowsPerPage:this.onchangedRowsPerPaged,
                onChangePage:this.onchangedPage,
                renderExpandableRow: function(rowData, rowMeta){
                    return <MuiTableExpander data = {rowData}/>
                },
                isRowSelectable:function(dataIndex){
                    return true;
                },
                customToolbarSelect:this.onCustomToolbarSelect,
                textLabels: {
                    body: {
                      noMatch: "",
                      toolTip: "Sort",
                      columnHeaderTooltip: column => `Sort for ${column.label}`
                    },
                    pagination: {
                      next: "შემდეგი გვერდი",
                      previous: "წინა გვერდი",
                      rowsPerPage: "ჩანაწერის რაოდენობა გვერდზე:",
                      displayRows: "of",
                    },
                    selectedRows: {
                      text: "მონიშნული ჩანაწერი",
                      delete: "Delete",
                      deleteAria: "Delete Selected Rows",
                    },
                  },
            }
        }

        this.interval = null;
        
    }
    
    onSort(changedColumn, direction){
        this.setState({
            order:{
                column:changedColumn,
                dir:direction,
                index:indexes[changedColumn]
            }
         })
    }
    propsChanged(prevProps){
        if(prevProps.type !== this.props.type || prevProps.status !== this.props.status ||prevProps.search !==this.props.search){
            this.tableRef.current.changePage(0)
            this.setState({
                ...this.state,
                currentPage:0,
                options:{
                    ...this.state.options,
                    page:0
                }
            })
            
            return true;
        }
        return false;
    }
    componentDidMount(){
        
        this.fetchData(this.props.type,this.props.status,this.props.search,this.state.currentPage,this.state.paginationPerPage);
        this.interval = setInterval(
            () => this.fetchData(this.props.type,this.props.status,this.props.search,this.state.currentPage,this.state.paginationPerPage),
        60000); 
    }

    componentWillUnmount(){
        clearInterval(this.interval);
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if(this.propsChanged(prevProps)|| prevState.paginationPerPage !== this.state.paginationPerPage||
            prevState.currentPage !== this.state.currentPage || JSON.stringify(this.state.order) !==JSON.stringify(prevState.order))   
        {
                
            this.fetchData(this.props.type,this.props.status,this.props.search,this.state.currentPage,this.state.paginationPerPage);
        }
    }


    onPDFButtonClick(id,type,firstname,lastname,personal_number){
        switch (type){
            case 'ახალი STB':
                console.log(type,firstname,lastname);
                this.props.history.push("/pdf/new/"+id+'/'+firstname+'/'+lastname+'/'+personal_number);
                break;
            case 'შესაცვლელია STB':
                this.props.history.push("/pdf/replace/"+id+'/'+firstname+'/'+lastname+'/'+personal_number);
                break;
            case 'წამოსაღებია STB' :
                this.props.history.push("/pdf/remove/"+id+'/'+firstname+'/'+lastname+'/'+personal_number);
                break;
            default :
                this.props.history.push("/pdf/replace/"+id+'/'+firstname+'/'+lastname+'/'+personal_number);
                break;

        }
        
    }
    fetchData(type,status,search,page,perPage){
        var order = this.state.order
         axiosInstance.get("server-processing.php", {
             params: {
                 columns : {
                     ...GETColumns
                 },
                order:[
                    order
                 ],
                 start:page * perPage,
                 length:perPage,
                 search:{
                    value:search,
                    regex:false
                 },
                 filter:{
                    type:type,
                    status:status
                 }
             },
             'paramsSerializer': function(params) {
                 return qs.stringify(params)
              },
         })
         .then(data =>this.onFetch(data.data))
         .catch(err => {
             if(err.response.status === 401){
                this.props.history.push('/login')
             }
         })
    }
    onchangedPage(page,totalRows){
        this.setState({
            ...this.state,
            currentPage:page,
            options:{
                ...this.state.options,
                page:page
            }
        })
    }
    onchangedRowsPerPaged(currentRowsPerPage, currentPage){
        this.setState({
            ...this.state,
            paginationPerPage:currentRowsPerPage,
            currentPage:currentPage
        })
    }
    onFetch(data){
        console.log(data);
        this.setState({
            ...this.state,
            data:data.data,
            options:{
                ...this.state.options,
                count:data.recordsFiltered
            }
        })
    }
    onChangeDataClicked(event,data){
        this.setState({
            ...this.state,
            show:true,
            updatingData:data
        })
    }



    deleteData(event,id){
        var data = new FormData();
        data.append('action','remove');
        data.append('id',this.state.ticket_id)
        axiosInstance.post("api.php",data)
        .then(data =>this.afterInsert(data))
        .catch(err => console.log("error: "+err))
        this.close_modal();
    }

    closeData(){
        var data = new FormData();
        data.append('action','close');
        data.append('id',this.state.ticket_id)
        axiosInstance.post("api.php",data)
        .then(data =>this.afterClose(data))
        .catch(err => console.log("error: "+err))
        this.close_modal();
    }




    onFinishTicket(){
        var data = new FormData();
        data.append('action','finish');
        data.append('id',this.state.ticket_id)
        axiosInstance.post("api.php",data)
        .then(data =>this.afterClose(data))
        .catch(err => console.log("error: "+err))
        this.close_modal();
    }


    onTakeTicket(event,id){
        var data = new FormData();
        data.append('action','take');
        data.append('id',id)
        axiosInstance.post("api.php",data)
        .then(data =>this.afterClose(data))
        .catch(err => console.log("error: "+err))
    }


    show_modal(ticket_id,modal_text,modal_ok_function){
        this.setState({
            ...this.state,
            modal_show:true,
            ticket_id:ticket_id,
            modal_text:modal_text,
            modal_ok_function:modal_ok_function
        })
    }
    close_modal(){
        this.setState({
            ...this.state,
            modal_show:false
        })
    }

    onCustomToolbarSelect(selectedRows,displayData,setSelectedRows){
        if(displayData.length > 0 ){
            var data = displayData[selectedRows.data[0]['index']].data
            if(this.props.role === '1'){
                if(data[2]==='შესრულებული'){
                    return (
                        <ButtonToolbar>
                            <ButtonGroup>
                                <Button className = "warning_btn"variant="warning" onClick={(event)=> this.onChangeDataClicked(event,data)}>შესწორება</Button>
                            </ButtonGroup>
                            <ButtonGroup >
                                <Button className = "success_btn" variant="success" onClick={(event)=>this.show_modal(data[13],'დანამდვილებით გსურთ დახურვა?',this.closeData)}>დახურვა</Button>
                            </ButtonGroup>
                            <ButtonGroup >
                                <Button className = "btn-info" variant="success" onClick={(event)=>this.onPDFButtonClick(data[0],data[1],data[7],data[8],data[14])}>PDF</Button>
                            </ButtonGroup>
                        </ButtonToolbar>
                        
                    )
                }else{
                    return (
                        <ButtonToolbar>
                            <ButtonGroup>
                                <Button className = "danger_btn"variant="danger" onClick={(event)=>this.show_modal(data[13],'დანამდვილებით გსურთ წაშლა?',this.deleteData)}>წაშლა</Button>
                            </ButtonGroup>
                            <ButtonGroup>
                                <Button className = "warning_btn"variant="warning" onClick={(event)=>this.onChangeDataClicked(event, data)}>შესწორება</Button>
                            </ButtonGroup>
                            <ButtonGroup >
                                <Button className = "btn-info" variant="success" onClick={(event)=>this.onPDFButtonClick(data[0],data[1],data[7],data[8],data[14])}>PDF</Button>
                            </ButtonGroup>
                            
                        </ButtonToolbar>
                    )
                }
            }else{
                if(data[2]==='მიმდინარე'){
                    return (
                        <ButtonToolbar>
                            <ButtonGroup >
                                <Button className = "success_btn" variant="success" onClick={(event)=>this.show_modal(data[13],'დანამდვილებით გსურთ დასრულება?',this.onFinishTicket)} >დასრულება</Button>
                            </ButtonGroup>
                            <ButtonGroup >
                                <Button className = "btn-info" variant="success" onClick={(event)=>this.onPDFButtonClick(data[0],data[1],data[7],data[8],data[14])}>PDF</Button>
                            </ButtonGroup>
                        
                        </ButtonToolbar>
                    )
                }else if(data[2]==='გახსნილი'){
                    return (
                        <ButtonToolbar>
                            <ButtonGroup >
                                <Button className = "success_btn" variant="success" onClick={(event)=>this.onTakeTicket(event,data[13])}>მიღება</Button>
                            </ButtonGroup>
                            <ButtonGroup >
                                <Button className = "btn-info" variant="success" onClick={(event)=>this.onPDFButtonClick(data[0],data[1],data[7],data[8],data[14])}>PDF</Button>
                            </ButtonGroup>
                            
                        </ButtonToolbar>
                    )
                }
            }
        }
    
    }
    setSmShow(value){
        this.setState({
            ...this.state,
            show:value
        })
    }

    afterInsert(){
        console.log('here')
        this.setState({
            ...this.state,
            show:false
        })
        this.fetchData(this.props.type,this.props.status,this.props.search,this.state.currentPage,this.state.paginationPerPage);
    }


    afterDelete(){
        this.fetchData(this.props.type,this.props.status,this.props.search,this.state.currentPage,this.state.paginationPerPage);
    }

    afterClose(){
        this.fetchData(this.props.type,this.props.status,this.props.search,this.state.currentPage,this.state.paginationPerPage);
    }

    updateData(current,id){
        console.log('updateData');
        var data = new FormData();
        data.append('action','update');
        data.append('billing_number',current.state.billing_number);
        data.append('first_name', current.state.first_name);
        data.append('last_name', current.state.last_name);
        data.append('definition', current.state.definition);
        data.append('phone', current.state.phone);
        data.append('comment', current.state.comment);
        data.append('address',current.state.address);
        data.append('city',current.state.city)
        data.append('id',id);


        axiosInstance.post("api.php",data)
        .then(data =>this.afterInsert(data))
        .catch(err => console.log("error: "+err))
    }
    render(){
        return(
            <div className="container-fluid">
                <MUIDataTable
                    innerRef={this.tableRef}
                    title={this.props.title}
                    data={this.state.data}
                    columns={columns}
                    options={{...this.state.options} }
                    />
                    <Modal 
                        show={this.state.show} 
                        centered 
                        size="lg"
                        onHide={() => this.setSmShow(false)}
                        >
                        <Modal.Header closeButton>
                        </Modal.Header>
                        <Modal.Body>
                           <UpdateModal ref={this.childRed} data={this.state.updatingData}/>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="success" onClick={()=>this.updateData(this.childRed.current,this.state.updatingData[13])}>
                                განახლება
                            </Button>
                            <Button variant="secondary" onClick={()=>this.setSmShow(false)}>
                                გამოსვლა
                            </Button>
                            
                        </Modal.Footer>
                    </Modal>
                    <Modal show= {this.state.modal_show} centered>
                        <Modal.Body>
                            {this.state.modal_text}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="success" onClick ={(event)=>this.state.modal_ok_function()} >
                                დიახ
                            </Button>
                            <Button variant="secondary" onClick ={(event)=>this.close_modal()} >
                                არა
                            </Button>
                        </Modal.Footer>
                    </Modal>   
            </div>
        )
    }
}
export default withRouter(MuiTable);